/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppReleaseDto } from '../../models/app-release-dto';

export interface AppReleaseControllerFindById$Params {
  id: string;
}

export function appReleaseControllerFindById(http: HttpClient, rootUrl: string, params: AppReleaseControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppReleaseDto>;
    })
  );
}

appReleaseControllerFindById.PATH = '/api/app-releases/{id}';
